import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IForm } from '../../../../models/form.model';
import { IIcd10 } from '../../../../models/icd10.model';
import { ISibasiHTTPResponse } from '../../../../models/sibasiHTTPResponse.model';
import { UserRoles } from '../../../../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(
    private httpClient: HttpClient
  ) { }

  getFormsByRole(): Observable<ISibasiHTTPResponse<IForm[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IForm[]>>(`${environment.api_url}/forms/getByRole`);
  }

  getAllForms(): Observable<ISibasiHTTPResponse<IForm[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IForm[]>>(`${environment.api_url}/forms/all`);
  }

  createForm(form: Partial<IForm>): Observable<ISibasiHTTPResponse<IForm>> {
    return this.httpClient.post<ISibasiHTTPResponse<IForm>>(`${environment.api_url}/forms`, form);
  }

  updateForm(form: Partial<IForm>, formId: string): Observable<ISibasiHTTPResponse<IForm>> {
    return this.httpClient.post<ISibasiHTTPResponse<IForm>>(`${environment.api_url}/forms/update/${formId}`, form);
  }

  getFormById(formId: string): Observable<ISibasiHTTPResponse<IForm>> {
    return this.httpClient.get<ISibasiHTTPResponse<IForm>>(`${environment.api_url}/forms/${formId}`);
  }

  deleteForm(formId: string): Observable<ISibasiHTTPResponse<IForm>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IForm>>(`${environment.api_url}/forms/delete/${formId}`);
  }

  assignUserRole(role: {role: UserRoles}, formId: string): Observable<ISibasiHTTPResponse<IForm>> {
    return this.httpClient.post<ISibasiHTTPResponse<IForm>>(`${environment.api_url}/forms/${formId}/assignRole`, role);
  }

  unAssignUserRole(role: {role: UserRoles}, formId: string): Observable<ISibasiHTTPResponse<IForm>> {
    return this.httpClient.post<ISibasiHTTPResponse<IForm>>(`${environment.api_url}/forms/${formId}/removeRole`, role);
  }

  initializeForms(): Observable<ISibasiHTTPResponse<IForm[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IForm[]>>(`${environment.api_url}/forms/new/default`);
  }
  getICD10Codes(): Observable<ISibasiHTTPResponse<IIcd10[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IIcd10[]>>(`${environment.api_url}/icd10`);
  }
}
